import { Drawer as ADrawer } from '@didi-pebble/pebble-design-react';

import { useIsMobile } from '@/utils';

const ResponsiveDrawer = ({ width = 378, ...props }: any) => {
  const isMobile = useIsMobile();

  return <ADrawer width={isMobile ? '100%' : width} {...props} />;
};

export default ResponsiveDrawer;
